var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { ButtonNew, ButtonNewVariant } from 'root/src/client/v2/common/components/form/ButtonNew';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import toast from 'react-hot-toast';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { queryClient } from 'root/src/client/v2/common/clients/queryClient';
import { giveawaysQueryKeys } from 'root/src/shared/giveaways/giveaways.keys';
import { useScheduleQuery } from 'root/src/client/v2/giveaways/hooks/api/giveawaySchedulerApi';
import { useGiveawayActive } from 'root/src/client/v2/giveaways/features/GiveawayHistory/hooks/useGiveawayHistory';
import { ModalLoader } from 'root/src/client/v2/common/components/modal/ModalLoader';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
export const CancelGiveawayConfirmationModal = () => {
    const modal = useModal();
    const { onSubmit, isLoading, isSubmitting, scheduler, cancelScheduler, onCancelScheduler } = useCancelGiveawayConfirmationModal();
    if (isLoading) {
        return <ModalLoader />;
    }
    return (<ModalLayout>
			<div className="flex flex-col justify-center items-center gap-4 pb-4">
				<ModalTitle>Do you want to cancel the Giveaway?</ModalTitle>
				<p className="text-center text-light-5">
					No one will receive a reward!
				</p>
				{scheduler && (<div className="flex items-center">
						<CancelSchedulerField value={cancelScheduler} onChange={onCancelScheduler}/>
					</div>)}
				<div className="flex justify-center items-center gap-6">
					<ButtonNew disabled={isSubmitting} onClick={modal.hide} variant={ButtonNewVariant.Error} className="font-bold uppercase h-12" type="button">
						Back
					</ButtonNew>
					<ButtonNew disabled={isSubmitting} onClick={onSubmit} className="font-bold uppercase h-12 w-32" type="button">
						{isSubmitting ? <LoadingCircles width={20} height={20}/> : 'Confirm'}
					</ButtonNew>
				</div>
			</div>
		</ModalLayout>);
};
const CancelSchedulerField = ({ value, onChange }) => {
    return (<FormControl>
			<FormControlLabel sx={{ gap: 0.5 }} control={(<Checkbox value={value} onChange={(_, checked) => onChange(checked)}/>)} label="Do you want to cancel all scheduled giveaways?"/>
		</FormControl>);
};
const useCancelGiveawayConfirmationModal = () => {
    const modal = useModal();
    const creatorDataApi = useCreatorDataApi();
    const activeGiveawayQuery = useGiveawayActive();
    const activeGiveaway = activeGiveawayQuery.giveaway;
    const schedulerQuery = useScheduleQuery();
    const scheduler = schedulerQuery.data;
    const cancelGiveawayMutation = trpc.giveaways.cancelGiveaway.useMutation();
    const [isSubmitting, setSubmitting] = useState(false);
    const [cancelScheduler, setCancelScheduler] = useState(false);
    const onCancelScheduler = (checked) => {
        setCancelScheduler(checked);
    };
    const onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!activeGiveaway) {
            toast.error('No active giveaways');
            modal.hide();
            return;
        }
        setSubmitting(true);
        try {
            yield cancelGiveawayMutation.mutateAsync({
                giveawayId: activeGiveaway.id,
                cancelScheduler,
            });
        }
        catch (err) {
            const message = (_a = err.message) !== null && _a !== void 0 ? _a : 'Something went wrong';
            toast.error(message, { duration: 7000 });
        }
        setSubmitting(false);
        void creatorDataApi.fetchGiveaways(true);
        void creatorDataApi.fetchScheduler();
        void queryClient.invalidateQueries({ queryKey: giveawaysQueryKeys.giveawaysQueryKeySelector() });
        toast.success('The Giveaway successfully deactivated!');
        modal.hide();
    });
    return {
        onSubmit,
        isLoading: schedulerQuery.isFetching
            || schedulerQuery.isLoading
            || activeGiveawayQuery.isLoading,
        scheduler,
        isSubmitting,
        onCancelScheduler,
        cancelScheduler,
    };
};
